import { FactoryBuilder } from './FactoryBuilder'

import type { IFactory } from './IFactory'

export const factory: IFactory = (() => {
  return new FactoryBuilder()
})()
